import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';

export interface DeleteInvestigationAttachmentCommand { investigationId: string; attachmentId: string; }

@Injectable({ providedIn: 'root' })
export class DeleteInvestigationAttachmentUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(command: DeleteInvestigationAttachmentCommand): Observable<void> {
    return this._repository.deleteAttachment(command.investigationId, command.attachmentId);
  }
}
